import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/views/Home')
const About = () => import('@/views/About')
// const Brands = () => import('@/views/Brands')
const Contact = () => import('@/views/Contact')
const Store = () => import('@/views/Store')
const Default = () => import('@/views/Default')
const NotFound = () => import('@/views/errors/NotFound')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    // {
    //   path: '/brands',
    //   name: 'brands',
    //   component: Brands
    // },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/stores/:slug',
      name: 'store',
      component: Store,
      props: true
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: Default
    },
    {
      path: '/dsgvo',
      name: 'dsgvo',
      component: Default
    },
    {
      path: '/404',
      name: '404',
      component: NotFound
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})
